import { Megaphone, Calendar, Clock, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

const notices = [
  {
    id: 1,
    title: "New Analytics Module Released",
    message: "You can now view revenue and eCPM in the Web and App Analytics tab.",
    date: "2025-06-20",
  },
  {
    id: 2,
    title: "Payment Cycle Updated",
    message: "Next payment date for publishers is July 5th, 2025.",
    date: "2025-06-18",
  },
  {
    id: 3,
    title: "Dashboard UI Enhancement",
    message: "Improved dashboard speed and responsiveness for a smoother experience.",
    date: "2025-06-15",
  },
  {
    id: 5,
    title: "Security Update",
    message: "We’ve added extra encryption layers to ensure your data remains protected.",
    date: "2025-06-10",
  },
  {
    id: 6,
    title: "Notice Board Revamp",
    message: "All important updates will now appear here. Stay tuned for new features!",
    date: "2025-06-08",
  },
];


export default function NoticeBoard() {
return (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.2, duration: 0.5 }}
    whileHover={{ y: -2 }}
    className="relative bg-white/90 backdrop-blur-sm p-6 rounded-2xl border border-gray-100 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden"
  >
    {/* Decorative glow */}
    <div className="absolute -right-10 -top-10 w-32 h-32 rounded-full bg-indigo-100/30 filter blur-xl -z-0" />
    
    <div className="relative z-10">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 rounded-lg bg-indigo-50 border border-indigo-100 shadow-sm">
          <Megaphone className="w-5 h-5 text-indigo-600" />
        </div>
        <h3 className="text-xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
          Announcements
        </h3>
      </div>

      <ul className="space-y-5">
        {notices.map((notice) => (
          <motion.li 
            key={notice.id}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3 }}
            whileHover={{ x: 3 }}
            className="relative pl-5 py-3 rounded-lg hover:bg-indigo-50/50 transition-colors duration-200 group"
          >
            {/* Timeline indicator */}
            <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-indigo-200 group-hover:bg-indigo-400 transition-colors">
              <div className="absolute -left-1.5 top-4 w-3 h-3 rounded-full bg-indigo-500 border-2 border-white shadow-sm" />
            </div>

            <div className="flex flex-col space-y-1">
              <div className="flex justify-between items-start">
                <p className="text-sm font-semibold text-gray-800 group-hover:text-indigo-700 transition-colors">
                  {notice.title}
                </p>
                <span className="text-xs px-2 py-1 bg-indigo-100 text-indigo-700 rounded-full">
                  {notice.priority}
                </span>
              </div>
              <p className="text-sm text-gray-600 group-hover:text-gray-800 transition-colors">
                {notice.message}
              </p>
              <div className="flex items-center mt-1 space-x-3">
                <span className="text-xs text-gray-400 flex items-center">
                  <Calendar className="w-3 h-3 mr-1" />
                  {notice.date}
                </span>
                <span className="text-xs text-gray-400 flex items-center">
                  <Clock className="w-3 h-3 mr-1" />
                  {notice.time}
                </span>
              </div>
            </div>
          </motion.li>
        ))}
      </ul>

      <div className="mt-6 pt-4 border-t border-gray-100 flex justify-end">
        <button className="text-sm font-medium text-indigo-600 hover:text-indigo-800 flex items-center transition-colors">
          View all announcements
          <ArrowRight className="w-4 h-4 ml-1" />
        </button>
      </div>
    </div>
  </motion.div>
);
}
